import React, { useState, useEffect } from "react";

const SimpleFadeIn = ({ children, duration = "0.15s" }) => {
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    let isMounted = true;
    if (!fadeIn) {
      setTimeout(() => {
        if (isMounted) {
          setFadeIn(true);
        }
      }, 20);
    }
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div
      className={"fade" + (fadeIn ? " show" : "")}
      style={{ transition: `opacity ${duration} linear` }}
    >
      {children}
    </div>
  );
};

export default SimpleFadeIn;
